import { render, staticRenderFns } from "./AceAdmin.vue?vue&type=template&id=af4f3436&"
import script from "./AceAdmin.vue?vue&type=script&lang=ts&"
export * from "./AceAdmin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports